import {Injectable} from '@angular/core';
import {Pedido} from "../interfaces/Pedido";
import {Bulto} from "../interfaces/Bulto";

interface tempStatePedido {
  sg123: string;
  clientCall?: Date;
}

interface tempStateBulto {
  ubicacion: string | undefined,
  isChecked: boolean
}

@Injectable({
  providedIn: 'root'
})
export class TempStateService {

  private tempStatesPedidos: tempStatePedido[] = [];
  private tempStateBultos: Map<string, Map<string, tempStateBulto>> = new Map<string, Map<string, tempStateBulto>>();

  constructor() {
  }

  updateCondition(sg123: string, condition: { key: keyof tempStatePedido, value: string }): void {
    const currentPedido = this.tempStatesPedidos.find(p => p.sg123 === sg123);

    if (currentPedido) {
      Reflect.set(currentPedido, condition.key, condition.value);
    } else {
      const newPedido = {sg123, [condition.key]: condition.value};
      this.tempStatesPedidos.push(newPedido);
    }
  }

  getCondition(sg123: string, condition: keyof tempStatePedido): string | null | undefined | Date {
    const currentPedido = this.tempStatesPedidos.find(p => p.sg123 === sg123);

    if (currentPedido) return Reflect.get(currentPedido, condition);
    return null;
  }

  clearUnfoundPedidos(pedidos: any[][]) {
    this.tempStatesPedidos = this.tempStatesPedidos.filter(pedido => pedidos.some(p => p[0] === pedido && p[1] === pedido));
  }

  updateBultos(sg123: string, bulto: Bulto): void {
    const currentBultos: Map<string, tempStateBulto> | undefined = this.tempStateBultos.get(sg123);

    if (currentBultos) {
      currentBultos.set(bulto.id, {ubicacion: bulto.ubicacion, isChecked: bulto.isChecked || false});
    } else {
      const newBulto = new Map<string, tempStateBulto>();
      newBulto.set(bulto.id, {ubicacion: bulto.ubicacion, isChecked: bulto.isChecked || false});
      this.tempStateBultos.set(sg123, newBulto);

    }

  }

  recoverBultoState(pedido: Pedido): void {
    const currentBultos: Map<string, tempStateBulto> | undefined = this.tempStateBultos.get(pedido.sg123);

    if (!currentBultos) return;

    pedido.bultos.forEach((bulto: Bulto) => {
      const currentBulto: tempStateBulto | undefined = currentBultos.get(bulto.id);
      if (currentBulto && currentBulto.ubicacion === bulto.ubicacion) bulto.isChecked = currentBulto.isChecked;
    });
  }

  cleanUnfoundBultos(pedidosEsperando: Pedido[], pedidosEnCamino: Pedido[], pedidosProgramados: Pedido[], pedidosPreparacion: Pedido[]): void {
    const pedidos = [...pedidosEsperando, ...pedidosEnCamino, ...pedidosProgramados, ...pedidosPreparacion];

    if (!pedidos.length) return;

    this.tempStateBultos.forEach((bultos, sg123) => {
      if (!pedidos.some(pedido => pedido.sg123 === sg123)) this.tempStateBultos.delete(sg123);
    });
  }

}
